import { __awaiter, __generator } from "tslib";
import { TuiFlowInTestMode } from '@office-start/teaching-ui-config-service';
var getSequenceSeenPromise = function (impressionEvent, config) {
    var tuiFlowInTestMode = config.teachingUiConfig.tuiFlowInTestMode;
    switch (tuiFlowInTestMode) {
        // TODO: First run vs returning
        case TuiFlowInTestMode.ReturningUserReact:
        case TuiFlowInTestMode.NewUserReact:
            return Promise.resolve(false);
        default:
            return config.userProfileService.doesMetricExist(impressionEvent);
    }
};
export var getValidator = function (config) {
    return function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var settings, id, impressionEvents, validPages, isRecurring, featureGateValidator, customValidator, markAsSeen, appMode, impressionPromise, context, featureGates, currentPage, currentAppMode, pageValid, workloadValid, featureGateValid, customValid, sequenceSeen, _a, tuiTestSequences, forceShowSequence, showForApp, valid, shouldShowSequence;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    settings = item.activationSettings, id = item.id;
                    // Some new user callouts have
                    // no activation settings
                    if (!settings) {
                        return [2 /*return*/, true];
                    }
                    impressionEvents = settings.impressionEvents, validPages = settings.pages, isRecurring = settings.isRecurring, featureGateValidator = settings.featureGates, customValidator = settings.customValidator, markAsSeen = settings.markAsSeen, appMode = settings.appMode;
                    impressionPromise = impressionEvents
                        ? Promise.all(impressionEvents.map(function (impressionEvent) {
                            return getSequenceSeenPromise(impressionEvent, config);
                        })).then(function (impressionResults) { return impressionResults.includes(true); })
                        : // If not defined we assume it has not been seen (only new user case at the moment)
                            Promise.resolve(false);
                    context = config.context, featureGates = config.featureGates;
                    currentPage = (_b = context.router.getCurrentRoute()) === null || _b === void 0 ? void 0 : _b.route;
                    currentAppMode = (_c = context.router.getCurrentRoute()) === null || _c === void 0 ? void 0 : _c.app;
                    pageValid = !validPages
                        ? // If setting does not exist mark as valid
                            true
                        : currentPage
                            ? // TODO: Fix OfficeRoute type checking
                                // Check if current route exists and is equal to one
                                // of the valid routes. If we fail to fetch a route default to false
                                validPages.includes(currentPage)
                            : false;
                    workloadValid = settings.workloads
                        ? settings.workloads.includes(context.workload)
                        : true;
                    featureGateValid = featureGateValidator
                        ? featureGateValidator(featureGates)
                        : true;
                    return [4 /*yield*/, (customValidator
                            ? customValidator(config)
                                .then(function (res) { return res; })
                                .catch(function (_) { return Promise.resolve(false); })
                            : Promise.resolve(true))];
                case 1:
                    customValid = _d.sent();
                    if (!isRecurring) return [3 /*break*/, 2];
                    _a = false;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, impressionPromise];
                case 3:
                    _a = _d.sent();
                    _d.label = 4;
                case 4:
                    sequenceSeen = _a;
                    tuiTestSequences = config.teachingUiConfig.tuiTestSequences;
                    forceShowSequence = tuiTestSequences.length
                        ? tuiTestSequences.includes(id.toLowerCase())
                        : false;
                    showForApp = appMode ? appMode == currentAppMode : true;
                    valid = !sequenceSeen &&
                        pageValid &&
                        workloadValid &&
                        featureGateValid &&
                        customValid &&
                        showForApp;
                    shouldShowSequence = valid || forceShowSequence;
                    if (!shouldShowSequence &&
                        (markAsSeen === null || markAsSeen === void 0 ? void 0 : markAsSeen(config)) &&
                        (item === null || item === void 0 ? void 0 : item.impressionEvent)) {
                        // Mark the callout as seen
                        config.userProfileService.incrementMetric(item.impressionEvent);
                    }
                    return [2 /*return*/, shouldShowSequence];
            }
        });
    }); };
};
//# sourceMappingURL=getValidator.js.map